import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, VerginaLoader } from 'components/UI'
// views
import { Container, GeneratingText, LoaderContainer } from './views'

const GENERATING_PHRASES = [
  'Analyzing context...',
  'Processing form data...',
  'Evaluating patterns...',
  'Synthesizing insights...',
  'Consulting knowledge base...',
  'Reviewing parameters...',
  'Optimizing response...',
  'Generating suggestions...'
]

interface Props {
  loading?: boolean
  onApply: () => void
  onTryAgain: () => void
  onCancel?: () => void
  applyDisabled?: boolean
}

const AiResultActions: React.FC<Props> = ({ onApply, onTryAgain, onCancel, applyDisabled, loading }) => {
  const [phraseIndex, setPhraseIndex] = React.useState(() => Math.floor(Math.random() * GENERATING_PHRASES.length))

  React.useEffect(() => {
    if (!loading) {
      return
    }

    const interval = setInterval(() => {
      setPhraseIndex((i) => (i + 1) % GENERATING_PHRASES.length)
    }, 2000)

    return () => clearInterval(interval)
  }, [loading])

  return (
    <>
      {loading && (
        <LoaderContainer>
          <VerginaLoader size={96} />
          <GeneratingText>{GENERATING_PHRASES[phraseIndex]}</GeneratingText>
        </LoaderContainer>
      )}
      <Container>
        {loading ? (
          <Button layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={onCancel}>
            Cancel
          </Button>
        ) : (
          <>
            <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={onApply} disabled={loading || applyDisabled}>
              Apply Changes
            </Button>
            <Button layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={onTryAgain}>
              Try Again
            </Button>
          </>
        )}
      </Container>
    </>
  )
}

export default AiResultActions
